import { render, staticRenderFns } from "./entityInfo.vue?vue&type=template&id=66109127&scoped=true&"
import script from "./entityInfo.vue?vue&type=script&lang=js&"
export * from "./entityInfo.vue?vue&type=script&lang=js&"
import style0 from "./entityInfo.vue?vue&type=style&index=0&id=66109127&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66109127",
  null
  
)

export default component.exports